import isEmpty from 'lodash/isEmpty';
import Accessory from 'src/types/shared/accessory';

function verifyAccessory(accessory: Accessory) {
	if (isEmpty(accessory.name)) {
		return 'Accessory name is missing';
	}

	if (isEmpty(accessory.calculationType)) {
		return 'Accessory calculation method is missing';
	}

	if (isEmpty(accessory.materials)) {
		return 'Accessory materials/labor are missing';
	}

	for (let i = 0; i < accessory.materials.length; i++) {
		const material = accessory.materials[i];

		if (isEmpty(material.name)) {
			return `Accessory ${i + 1} name is missing`;
		}

		if (material.unitsPerAccessory == 0) {
			return `Accessory ${i + 1} number of units is missing`;
		}

		if (material.maxAccessories == 0) {
			return `Accessory ${i + 1} max accessories is missing`;
		}

		if (material.price == 0) {
			return `Accessory ${i + 1} price is missing`;
		}

		if (isEmpty(material.category)) {
			return `Accessory ${i + 1} category is missing`;
		}
	}

	return null;
}

export default verifyAccessory;
